import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { IS_PROD } from './utils/env';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Force clear all caches and unregister service workers
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    // Unregister all service workers
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    
    // Clear all caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
  });
}

